// React
import React from 'react';

// Components
import Wrapper from '../../listing/Wrapper/Wrapper';

// Contexts
import { ListingContext } from '../../../contexts/listing';

// Hooks
import useListing from '../../../hooks/useListing';

// Data types
import {
  standardFeatureCore,
  standardFeatureListing
} from '../../../data-types/standardFeature';

// This component
export default function StandardFeature() {
  // Data types
  const { endpoint } = standardFeatureCore();
  const {
    initialSort,
    initialFilters,
    getColumns,
    getRows,
    getFilters
  } = standardFeatureListing();

  // Listing
  const {
    activeFilters,
    saveActiveFilters,
    page,
    pageSize,
    setPage,
    setPageSize,
    sortModel,
    setSortModel,
    resetSortModel,
    refreshDataGrid,
    setRefreshDataGrid
  } = useListing(initialSort, initialFilters, endpoint);

  // JSX
  return (
    <ListingContext.Provider
      value={{
        typeOfData: 'data-type',
        // Static
        initialFilters,
        endpoint,
        getColumns,
        getRows,
        getFilters,
        // Dynamic
        activeFilters,
        saveActiveFilters,
        page,
        pageSize,
        setPage,
        setPageSize,
        sortModel,
        setSortModel,
        resetSortModel,
        refreshDataGrid,
        setRefreshDataGrid
      }}>
      <Wrapper
        title="Standard Features"
        buttonNewLabel="New Standard Feature"
        buttonNewUrl="/standard-feature/new"
        exportAction={true}
        buttonExportLabel="Export Data"
      />
    </ListingContext.Provider>
  );
}
